import React from "react";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import { PREFERRED_PHONE_TYPES } from "assets/scripts/constants/Constants";
const options = [
    {
        value: "Home",
        label: PREFERRED_PHONE_TYPES.Home
    },
    {
        value: "Cell",
        label: PREFERRED_PHONE_TYPES.Cell
    },
    {
        value: "Work",
        label: PREFERRED_PHONE_TYPES.Work
    }
];
const PhoneTypeFormGroup = ({ nullOption, ...otherProps }) => (<SelectFormGroup {...otherProps} options={[
    {
        value: "Unspecified",
        label: nullOption
    },
    ...options
]}/>);
export default PhoneTypeFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/PhoneTypeFormGroup/PhoneTypeFormGroup.tsx